import React from 'react';
import SumOf from './SumOf';
import GreaterOf from './GreaterOf';
import GOx from './GOx';
import GOz from './GOz';
import Collections from './Collections';
import CollectionsOffset from './CollectionsOffset';
import ProdHurdle from './ProdHurdle';
import GoGa from './GoGa';

class EarningsReport extends React.Component {
    render() {
        switch (this.props.details.contractType) {
            case 'Sum Of':
            case 'Sum Of w/HYN':
                return <SumOf {...this.props} />;
            case 'Greater Of':
            case 'Greater Of w/HYN':
                return <GreaterOf {...this.props} />;
            case 'GOX':
            case 'GOX w/HYN':
                return <GOx {...this.props} />;
            case 'GOZ':
                return <GOz {...this.props} />;
            case 'Collections':
            case 'Collections w/HYN':
                return <Collections {...this.props} />;
            case 'Collections Offset':
                return <CollectionsOffset {...this.props} />;
            case 'Prod Hurdle':
                return <ProdHurdle {...this.props} />;
            case 'GO GA':
            case 'GO GA w/HYN':
                return <GoGa {...this.props} />;
            default:
                return null;
        }
    }
}

export default EarningsReport;